import { Baujahr, Mietspiegeljahr } from "./types";

export const baujahrSpannenByMietspiegeljahr = {
  "2015": [
    "-1918",
    "1919-1949",
    "1950-1964",
    "1965-1972",
    "W:1973-1990",
    "O:1973-1990",
    "1991-2002",
    "2003-2013",
  ],
  "2017": [
    "-1918",
    "1919-1949",
    "1950-1964",
    "1965-1972",
    "W:1973-1990",
    "O:1973-1990",
    "1991-2002",
    "2003-2015",
  ],
  "2019": [
    "-1918",
    "1919-1949",
    "1950-1964",
    "1965-1972",
    "W:1973-1990",
    "O:1973-1990",
    "1991-2002",
    "2003-2017",
  ],
  "2021": [
    "-1918",
    "1919-1949",
    "1950-1964",
    "1965-1972",
    "W:1973-1990",
    "O:1973-1990",
    "1991-2002",
    "2003-2017",
  ],
  "2023": [
    "-1918",
    "1919-1949",
    "1950-1964",
    "1965-1972",
    "W:1973-1990",
    "O:1973-1990",
    "1991-2002",
    "2003-2017",
  ],
  "2024": [
    "-1918",
    "1919-1949",
    "1950-1964",
    "1965-1972",
    "W:1973-1985",
    "W:1986-1990",
    "O:1973-1990",
    "1991-2001",
    "2002-2009",
    "2010-2015",
    "2016-2022",
  ],
  "2026": [
    "-1918",
    "1919-1949",
    "1950-1964",
    "1965-1972",
    "W:1973-1985",
    "W:1986-1990",
    "O:1973-1990",
    "1991-2001",
    "2002-2009",
    "2010-2015",
    "2016-2019",
    "2020-2024",
  ],
} satisfies { [key in Mietspiegeljahr]: Baujahr[] };
